import { render } from "./S3FileUpload.vue?vue&type=template&id=3fd15dc4"
import script from "./S3FileUpload.vue?vue&type=script&lang=js"
export * from "./S3FileUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__